module.exports = __webpack_public_path__ + "media/components/leaflet/static/placeholder-icon-1c14e1c15f790d2158169aebcc039857.svg";